<div class="regras-nfse">

  <app-regras-toolbar
    [busca]="busca"
    [filtroAtivo]="filtroAtivo"
    [situacaoOptions]="filtroSituacaoOptions"
    [carregando]="loading"
    placeholder="TES, CFOP ou descrição"
    rotuloNovo="Nova regra"
    (buscar)="filtrar($event)"
    (filtrarSituacao)="onFiltroSituacao($event)"
    (atualizar)="carregar()"
    (novo)="abrirNova()">
  </app-regras-toolbar>

  <app-regras-skeleton
    *ngIf="loading && !itens.length"
    rotulo="Carregando as regras de NFS-e">
  </app-regras-skeleton>

  <po-table
    *ngIf="!loading || itens.length"
    [p-columns]="columns"
    [p-items]="itens"
    [p-actions]="tableActions"
    [p-loading]="loading || loadingMore"
    [p-sort]="true"
    [p-striped]="true"
    [p-height]="tableHeight"
    [p-show-more-disabled]="!hasMore"
    (p-show-more)="carregarMais()">
  </po-table>

</div>

<po-modal
  #formModal
  [p-title]="modalTitle"
  p-size="lg"
  [p-primary-action]="modalPrimaryAction"
  [p-secondary-action]="modalSecondaryAction">

  <div class="regras-form" [formGroup]="formGroup">

    <div class="po-row" *ngIf="duplicando">
      <small class="po-md-12 po-font-text-small">
        Cópia da regra <b>{{ editing?.codigo }}</b>. A ordem de avaliação foi
        limpa de propósito: duas regras ativas do mesmo tipo de processo com a
        mesma ordem competiriam pela mesma nota.
      </small>
    </div>

    <div class="po-row">
      <po-select
        class="po-md-6"
        p-label="Filial da regra"
        p-help="Em branco, a regra vale para todas as filiais"
        [p-options]="filiaisOptions"
        formControlName="filial">
      </po-select>

      <po-select
        class="po-md-6"
        p-label="Tipo de processo"
        [p-options]="tipoProcessoOptions"
        formControlName="tipoProcesso"
        p-required>
      </po-select>
    </div>

    <div class="po-row">
      <po-select
        class="po-md-4"
        p-label="Gera financeiro"
        [p-options]="simNaoIndifOptions"
        formControlName="geraFinanceiro"
        p-required>
      </po-select>

      <po-select
        class="po-md-4"
        p-label="ISS retido"
        [p-options]="simNaoIndifOptions"
        formControlName="issRetido"
        p-required>
      </po-select>

      <po-select
        class="po-md-4"
        p-label="Demais retenções federais"
        p-help="PIS, COFINS, CSLL, IR e INSS"
        [p-options]="simNaoIndifOptions"
        formControlName="outrasRet"
        p-required>
      </po-select>
    </div>

    <div class="po-row">
      <po-combo
        class="po-md-6"
        p-label="Tipo de operação (TES)"
        p-filter-service="portalnf/regras/lookup/tes"
        [p-filter-params]="filtroTes"
        p-field-label="label"
        p-field-value="value"
        [p-sort]="true"
        name="tes"
        formControlName="tes"
        [p-required]="true"
        [p-infinite-scroll]="true">
      </po-combo>

      <po-combo
        class="po-md-3"
        p-label="CFOP de referência"
        p-filter-service="portalnf/regras/lookup/cfop"
        p-field-label="label"
        p-field-value="value"
        [p-sort]="true"
        name="cfop"
        formControlName="cfop"
        [p-infinite-scroll]="true">
      </po-combo>

      <po-number
        class="po-md-3"
        p-label="Ordem de avaliação"
        p-help="Vale a de menor ordem"
        formControlName="ordem"
        [p-min]="1"
        [p-max]="999"
        p-required>
      </po-number>
    </div>

    <div class="po-row">
      <po-input
        class="po-md-12"
        p-label="Descrição da regra"
        formControlName="descricao"
        [p-maxlength]="100">
      </po-input>
    </div>

    <div class="po-row">
      <po-datepicker
        class="po-md-4"
        p-label="Início da vigência"
        formControlName="dtIni">
      </po-datepicker>

      <po-datepicker
        class="po-md-4"
        p-label="Fim da vigência"
        p-help="Em branco = vigência em aberto"
        formControlName="dtFim">
      </po-datepicker>

      <po-select
        class="po-md-4"
        p-label="Situação"
        [p-options]="situacaoOptions"
        formControlName="ativo"
        p-required>
      </po-select>
    </div>

    <div class="po-row" *ngIf="editing?.usrAlt">
      <small class="po-md-12 po-font-text-small regras-auditoria">
        Última alteração por <b>{{ editing?.usrAltNome || editing?.usrAlt }}</b>
        em {{ formatarData(editing?.dtAlt) }} às {{ editing?.hrAlt }}.
      </small>
    </div>

  </div>

</po-modal>
